import { Collapse, Spin } from "antd";
import React, { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { useListVideos } from "hooks/use-list-videos";
import { getEmailAndVideoNameFromUrl } from "utils/helpers";
import moment from "moment";
import playIconVideo from "icons/video.png";
import { DeleteIcon, DownloadIcon, ReportIcon, VisualizeIcon } from "icons";
import { ConditionalRenderer } from "components";
import { UseLazyApiCallOldDashboard } from "hooks/use-lazy-api-call-old-dashboard";

export const VideosContainer = ({
  connectedStrikerId,
  date,
  userHistory,
  goTo,
  getClickedVideo,
  search,
  item,
}) => {
  const deviceTypesLabels = {
    dc1: "DES",
    iOS: "IOS",
    and: "AND",
  };

  const [gridProperties, setGridProperties] = useState({
    noOfColumns: 9,
    gridGap: "20px",
  });
  const [fileId, setFileId] = useState();
  const [showUrl, setShowUrl] = useState(null);
  const [videoModalOpen, setVideoModalOpen] = useState({
    playVideoModal: false,
  });

  const payload = {
    userID: connectedStrikerId,
    date,
  };
  const {
    data: videos,
    isLoading,
    error,
    inValidateQuery,
    refetchVideos,
  } = useListVideos({ payload, skip: !connectedStrikerId || !date });

  useEffect(() => {
    if (!userHistory) return;
    const rowContainer =
      document.getElementsByClassName("ant-collapse-item")[0];
    if (rowContainer) {
      const { width } = rowContainer.getBoundingClientRect() || {};
      const noOfColumns = Math.floor(width / 185);
      const rowGap = (width - noOfColumns * 185) / (noOfColumns - 1);
      setGridProperties({
        noOfColumns: noOfColumns,
        gridGap: `${rowGap}px`,
      });
    }
  }, [userHistory]);
  function getvideoRowContainerClasses() {
    const darkModeClass = "";
    return [styles.videoCard, darkModeClass].join(" ");
  }
  function thumbnailHandler(el) {
    const fileIdLocal = getEmailAndVideoNameFromUrl(el?.url || el?.ulr2);
    setFileId(fileIdLocal);

    const activePanel = moment(el?.createdAt).format("YYYY-MM-DD");
    sessionStorage.setItem("activeId", JSON.stringify(activePanel));

    setShowUrl(el?.url);
    setVideoModalOpen({
      ...videoModalOpen,
      playVideoModal: true,
    });
  }

  function getSwingType(el) {
    function convertToShort(str) {
      const strArray = str?.split(" ");
      return strArray
        ?.map((item) => item[0])
        .join("")
        .toUpperCase();
    }
    if (el?.tracerTypeId) {
      return convertToShort(
        el?.tracerTypeId === 1 ? "Club Tracer" : "Short Tracer"
      );
    }
    return convertToShort(
      el?.swingTypeName === "Putting" ? "Putter" : el?.swingTypeName
    );
  }

  function getRecordingType(el) {
    const titleKey = el?.title?.split("-")[1];
    return deviceTypesLabels[titleKey];
  }
  function getVideoLabel(el) {
    if (el?.url && el?.url2) {
      return "FO + DTL";
    }

    if (el?.url && !el?.url2) {
      return "FO";
    }
    if (!el?.url && el?.url2) {
      return "DTL";
    }
  }
  function getForcePlateType(el) {
    return el?.forcePlateTypeName?.slice(0, 4);
  }

  const videosList = search ? item?.videos : videos?.videos;

  return (
    <Spin spinning={isLoading}>
      <div
        className={styles.videoContainer}
        style={{
          "--history-col": gridProperties.noOfColumns,
          "--history-row-gap": gridProperties.gridGap,
        }}
      >
        {videosList?.map((el, id) => {
          const displayTitle = el?.title?.split(".")[0];

          const modifiedDisplayTitle = displayTitle?.slice(-6);

          return (
            <div className={getvideoRowContainerClasses()}>
              <div className={styles.cardHeader}>
                <div className={styles.cardSubSection}>
                  <span
                    className={`${styles.cardImg}`}
                    onClick={() => thumbnailHandler(el)}
                  >
                    <img
                      src={`${el?.thumbnail}`}
                      alt="icon-play"
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = `${playIconVideo}`;
                      }}
                    />
                  </span>
                </div>

                <div className={styles.iconsContainer}>
                  <button type="button">
                    <VisualizeIcon
                      onClick={() => {
                        getClickedVideo(el);
                        goTo(3);
                      }}
                    />
                  </button>
                  <ConditionalRenderer condition={true}>
                    <button type="button">
                      <ReportIcon />
                    </button>
                  </ConditionalRenderer>
                  <button type="button">
                    <DownloadIcon />
                  </button>{" "}
                  <button type="button">
                    <DeleteIcon />
                  </button>
                </div>
              </div>
              <div className={styles.displayTitle}>
                <ConditionalRenderer condition={el?.title}>
                  <DisplayTitle
                    // title={modifiedDisplayTitle}
                    title={el?.title}
                  />
                </ConditionalRenderer>
                {/* <span className={styles.tooltip}>
                                    {el?.title}
                                  </span> */}
              </div>
              <div className={`${styles.cardBody}`}>
                <div className={styles.cardFooter}>
                  <div className={styles.videoDescription}>
                    <ConditionalRenderer condition={!el?.isLaunchMonitor}>
                      <VideoLabel
                        // title={"P"}
                        title={getSwingType(el) ?? "P"}
                        bg={"#006AB3"}
                      />
                      <VideoLabel
                        // title={"hi"}
                        title={getVideoLabel(el)}
                        bg={"#7BB728"}
                      />
                      <VideoLabel
                        title={el?.clubTypeName?.charAt(0) ?? "I"}
                        // title={"hi"}
                        bg={"#F4BD00"}
                      />
                      <ConditionalRenderer
                        condition={"hi"}
                        // condition={getRecordingType(el)}
                      >
                        <VideoLabel
                          // title={"hi"}
                          title={getRecordingType(el)}
                          bg={"#326971"}
                        />
                      </ConditionalRenderer>
                      <ConditionalRenderer condition={el?.forcePlateTypeName}>
                        <VideoLabel
                          // title={"hi"}
                          title={getForcePlateType(el)}
                          bg={"#ABA7AF"}
                        />
                      </ConditionalRenderer>
                      <VideoLabel
                        // title={"hi"}
                        title={
                          el?.isCalibrated ? "Calibrated" : "Not Calibrated"
                        }
                        bg={"#F63E5099"}
                      />
                    </ConditionalRenderer>
                    <ConditionalRenderer condition={el?.isLaunchMonitor}>
                      <VideoLabel
                        title={getSwingType(el) ?? "P"}
                        bg={"#006AB3"}
                      />
                      <VideoLabel title={getVideoLabel(el)} bg={"#7BB728"} />

                      <VideoLabel title="LM" bg={"#F4BD00"} />
                    </ConditionalRenderer>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </Spin>
  );
};

function DisplayTitle({ title }) {
  return <p className={styles.title}>{title}</p>;
}
// function DisplayTitle({ title }) {
//   const firstTitle = title?.slice(0, 4).toUpperCase() || "";
//   if (firstTitle.includes("M2C")) {
//     const lastTitle = title?.slice(4);
//     const titleArray = [firstTitle, lastTitle];
//     const titleJSX = titleArray?.map((state, idx) => (
//       <p className={styles.title} key={idx}>
//         {state}
//       </p>
//     ));
//     return titleJSX;
//   }

//   return <p className={styles.title}>{title}</p>;
// }

function VideoLabel({ title, bg }) {
  return (
    <p style={{ backgroundColor: bg }} className={styles.videoLabels}>
      {title}
    </p>
  );
}
function DateHeader({ title }) {
  const date = new Date(title);

  const options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };

  const formattedDate = date.toLocaleDateString(undefined, options);

  return <div className={styles.collapseItemHeader}>{formattedDate}</div>;
}
